export default __webpack_public_path__ + "static/media/Dash 2.4a0cccdd.png";